import Index from '../pages/main'

const Main = {
  name: 'main',
  path: '/',
  element: <Index />,
}

export default Main
